function checkStickyHeader(header, scrollY) {
    if (scrollY > 0) {
        header.classList.add('is-stuck');
    } else {
        header.classList.remove('is-stuck');
    }
}

$(document).ready(function()
{
    let stickyHeader = document.querySelector('.header');
    let lastScrollPos = window.scrollY;
    let ticking = false;
    checkStickyHeader(stickyHeader, lastScrollPos);
    window.addEventListener('scroll', function(e)
    {
        lastScrollPos = window.scrollY;
        if (!ticking) {
            window.requestAnimationFrame(function()
            {
                checkStickyHeader(stickyHeader, lastScrollPos);
                ticking = false;
            });
            ticking = true;
        }
    });
});
